function showZoomRescueScreen() {
  const message =
    '<h1 class="zoom-doctor-message" style="color:white; font-size:10px; display: inline; margin-left:20px; margin-right:20px;">Zoom out to return to the app</h1>'
  const warningMessage = `<div style="padding: 20px;">${message}</div>`
  if (!document.getElementById('zoom-doctor-rescue-screen')) {
    const div = document.createElement('div')
    div.style.background = 'rgba(0, 0, 0, 0.7)'
    div.style.position = 'fixed'
    div.style.top = '0px'
    div.style.right = '0px'
    div.style.bottom = '0px'
    div.style.left = '0px'
    div.style.overflow = 'hidden'
    div.style['z-index'] = 999999999999
    div.innerHTML = `<div style="padding-top:20px; padding-top:30vh; padding-bottom:20px; text-align:center;">
      ${warningMessage}
    </div>`
    div.id = 'zoom-doctor-rescue-screen'
    document.body.appendChild(div)
  }
}

function hideZoomRescueScreen() {
  if (document.getElementById('zoom-doctor-rescue-screen')) {
    document.getElementById('zoom-doctor-rescue-screen').outerHTML = ''
    delete document.getElementById('zoom-doctor-rescue-screen')
  }
}

function isZoomed() {
  const approximateZoom = document.documentElement.clientWidth / window.innerWidth
  return approximateZoom !== 1
}

function assessZoomLevel() {
  if (isZoomed()) {
    showZoomRescueScreen()
    setTimeout(() => {
      assessZoomLevel()
    }, 500)
  } else {
    hideZoomRescueScreen()
  }
}

function init() {
  // - stop the user from 'pinch zooming' (unless they already seem to be in a zoomed state)
  document.body.addEventListener(
    'touchmove',
    (event) => {
      if (event.touches.length > 1 && !isZoomed()) {
        event.preventDefault()
      }
    },
    {
      passive: false,
    }
  )
  // - stop the user from 'double tap zooming'
  let tappedTwice = false
  document.body.addEventListener(
    'touchstart',
    (event) => {
      if (!tappedTwice) {
        tappedTwice = true
        setTimeout(() => {
          tappedTwice = false
        }, 300)
      } else if (!isZoomed()) {
        event.preventDefault()
      }
    },
    {
      passive: false,
    }
  )
  // show the zoom rescue screen if a zoom level is detected
  document.body.addEventListener('touchstart', () => {
    assessZoomLevel()
  })
  document.body.addEventListener('touchend', () => {
    assessZoomLevel()
  })
  document.body.addEventListener('touchmove', () => {
    assessZoomLevel()
  })
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./src/lib/zoomDoctor.js